// extracted by css-extract-rspack-plugin
export default {"LighthouseContainer":"yojrr","LighthouseImage":"jmjV_"};